import React from 'react';
import dayjs from 'dayjs';
import {
  Calendar,
  CircleUser,
  FileText,
  List,
  Megaphone,
  MessageCircleWarning,
} from 'lucide-react';
import { useDispatch } from 'react-redux';
import { Typography } from '@/components/novoville';
import { translate } from '../../services/TranslationService';
import { goTo } from '../../shared/actions';

const historyIconMap = {
  EVENT: <Calendar className="h-5 w-5 text-purpleLink" />,
  REPORTS: <FileText className="h-5 w-5 text-success" />,
  PERSONAL: <CircleUser className="h-5 w-5 text-darkOrange" />,
  ANNOUNCEMENT: <MessageCircleWarning className="h-5 w-5 text-blueLink" />,
  POLL: <List className="h-5 w-5 text-peach" />,
  ALL: <Megaphone className="h-5 w-5 text-blueLink" />,
};

const getHistoryIcon = (appType) =>
  historyIconMap[appType?.startsWith('REPORT') ? 'REPORTS' : appType] ||
  historyIconMap['ALL'];

const ReportHistory = ({ report }) => {
  const dispatch = useDispatch();
  const reportHistory = Array.isArray(report?.history) ? report.history : [];

  if (reportHistory.length === 0) return null;

  return (
    <div className="flex flex-col gap-[16px]">
      <Typography variant="bold_20" className="text-gray-800">
        {translate('History')}
      </Typography>
      <div className="flex flex-col gap-[16px]">
        {reportHistory.map((item, index) => {
          const message = {
            ...item,
            authority_name: item?.authority_name || report?.authority_name,
          };

          return (
            <button
              key={item?.id ?? index}
              type="button"
              onClick={() =>
                dispatch(
                  goTo('messages', item.id, {
                    message,
                    cameFrom: 'ReportDetails',
                  })
                )
              }
              className="flex w-full cursor-pointer flex-col gap-[8px] rounded-lg border border-gray-200 p-[16px] text-left hover:bg-gray-50"
            >
              <div className="flex flex-col gap-[8px] sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-[12px]">
                  <div className="flex h-[32px] w-[32px] items-center justify-center rounded-md bg-gray-100">
                    {getHistoryIcon(item?.app_type)}
                  </div>
                  <Typography variant="semibold_16" className="text-gray-800">
                    {translate(item?.app_type)}
                  </Typography>
                </div>
                <div className="flex items-center gap-[8px]">
                  <Typography variant="regular_14" className="text-gray-400">
                    {`#${report.id}`}
                  </Typography>
                  <Typography variant="regular_14" className="text-gray-400">
                    •
                  </Typography>
                  <Typography variant="regular_14" className="text-gray-400">
                    {dayjs(item?.created_at).format('DD-MM-YYYY')}
                  </Typography>
                </div>
              </div>
              <Typography variant="regular_16" className="text-gray-700">
                {item?.title}
              </Typography>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReportHistory;
